import React, { useEffect, useState } from "react";
import {
  centralAuth,
  forgetpasswordService,
  useLoginMutation,
} from "../../redux/service/authService";
import { setLocalStorage, isCaregiver, isPatient } from "../../userStore";
import { useNavigate } from "react-router-dom";
import Logo from "../../assests/images/login-logo.png";
import { toast } from "react-toastify";
import TOSModal from "../../components/TOSModal";
import { useForm } from "react-hook-form";
import { InputField } from "../../components/ReactHooksFormFields/inputField";
import FullScreenLoader from "../../components/FullScreenLoader";
import { useAppContext } from "../../AppContext";
import { usePusherContext } from "../../components/pusher_context";
import { Loader } from "../../components/Loader";
import MainPageDialog from "../../components/mainPageDialog";

export const AppLogin = (props) => {
  const [forgetpassword, setForgetPassword] = useState(false);
  const [showForgetinfo, setShowForgetinfo] = useState(false);
  const [loginCall, { isLoading, error }] = useLoginMutation();
  const [loading, setLoading] = useState(false);
  const forgetpasswordForm = useForm();
  const {
    control,
    formState: { errors },
    setValue,
    handleSubmit,
  } = useForm({});
  const [showTosModal, setShowTosModal] = useState(false);
  const [userData, setUserData] = useState({});
  const navigate = useNavigate();
  const AppContext = useAppContext();
  const pusherContext = usePusherContext();

  useEffect(() => {
    AppContext.resetAppData();
    pusherContext.resetPusherData();
  }, []);

  const handleLogin = async (data) => {
    const payload = {
      device_login: "Web",
      from_mobile: 1,
      is_patient: 1,
      password: data.password,
      timezone: -300,
      username: data.username,
    };
    // localStorage.setItem("organization_code", data?.organization_code);
    // const result = await loginCall({ ...payload });
    // if (result.error) {
    //   console.error("Failed to login", result.error);
    // } else {
    //   if (result?.data?.User?.token) {
    //     const sessionData = {
    //       ...result?.data?.User,
    //       attending_physician: result?.data?.attending_physician || null,
    //     };
    //     //set login status true
    //     setUserData(sessionData);
    //     console.log("Login successful", result.data?.User);
    //     if (
    //       !sessionData?.tos_accepted ||
    //       // eslint-disable-next-line eqeqeq
    //       sessionData?.tos_accepted == 0
    //     ) {
    //       setShowTosModal(true);
    //     } else {
    //       setLocalStorage("isLoggedIn", true);
    //       setLocalStorage("session", sessionData);
    //       AppContext.updateAppData("selectedUser", sessionData);
    //       if (sessionData?.firstlogin === 1 || sessionData?.pincode === "") {
    //         navigate("/create-pin");
    //       } else {
    //         ///redirect to dashboard
    //         if (isPatient()) {
    //           navigate("/dashboard");
    //         } else if (isCaregiver()) {
    //           navigate("/patients");
    //         } else {
    //           ///redirect to dashboard
    //           if (isPatient()) {
    //             navigate("/dashboard");
    //           } else if (isCaregiver()) {
    //             navigate("/patients");
    //           } else {
    //             navigate("/dashboard");
    //           }
    //           toast.success("Login successful");
    //         }

    //         toast.success("Login successful");
    //         // window.location.reload();
    //       }
    //     }
    //   } else {
    //     console.log("Login failed", result.data?.User);
    //     toast.error(result?.data?.msg);
    //   }
    // }
    setLoading(true);
    centralAuth(payload)
      .then((result) => {
        setLoading(false);
        if (result?.data?.response?.data?.User?.token) {
          const sessionData = {
            ...result?.data?.response?.data?.User,
            attending_physician:
              result?.data?.response?.data?.attending_physician || null,
          };
          //set login status true
          setUserData(sessionData);
          setLocalStorage("baseUrl", sessionData?.server_api);
          if (
            !sessionData?.tos_accepted ||
            // eslint-disable-next-line eqeqeq
            sessionData?.tos_accepted == 0
          ) {
            setShowTosModal(true);
          } else {
            setLocalStorage("isLoggedIn", true);
            setLocalStorage("session", sessionData);
            AppContext.updateAppData("selectedUser", sessionData);
            if (sessionData?.firstlogin === 1 || sessionData?.pincode === "") {
              navigate("/create-pin");
            } else {
              ///redirect to dashboard
              if (isPatient()) {
                navigate("/dashboard");
              } else if (isCaregiver()) {
                navigate("/patients");
              } else {
                ///redirect to dashboard
                if (isPatient()) {
                  navigate("/dashboard");
                } else if (isCaregiver()) {
                  navigate("/patients");
                } else {
                  navigate("/dashboard");
                }
                toast.success("Login successful");
              }

              toast.success("Login successful");
            }
          }
        } else {
          toast.error(result?.data?.message || result?.data?.response?.msg);
        }
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  };
  const onCancelHandler = () => {
    setForgetPassword(false);
    forgetpasswordForm.clearErrors();
    setShowForgetinfo(false);
    forgetpasswordForm.setValue("email", "");
  };
  const submitForgetPassordHandler = (data) => {
    const formdata = new FormData();
    formdata.append("email", data.email);
    setLoading(true);
    forgetpasswordService(formdata).then((res) => {
      setLoading(false);
      if (res?.data?.response?.code == 0) {
        setShowForgetinfo(res?.data?.response);
      } else {
        toast.error(res?.data?.message);
      }
    });
  };
  return (
    <>
      {showTosModal && (
        <TOSModal
          userData={userData}
          setUserData={setUserData}
          setShowTosModal={setShowTosModal}
          agreementType="not_agreed"
        />
      )}
      {(isLoading || loading) && <FullScreenLoader />}
      <div className="my-5 sm:mx-auto sm:w-full sm:max-w-[480px] border border-gray-300 overflow-hidden rounded-xl bg-red-200 shadow-xl ">
        <div className="bg-white px-4 py-12 shadow sm:rounded-lg sm:px-12 ">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <img src={Logo} alt="" className="w-[237px] ml-16" />
            <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
              Sign in to your account
            </h2>
          </div>

          <form className="space-y-4 mt-5" method="POST" autoComplete="off">
            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
              <div className="mb-2 text-start">
                <InputField
                  control={control}
                  errors={errors}
                  name="username"
                  title="Username"
                  rules={{ required: true }}
                  autoComplete="off"
                />
              </div>
              <div className="mb-2 text-start">
                <InputField
                  control={control}
                  errors={errors}
                  name="password"
                  title="Enter Password"
                  rules={{ required: true }}
                  type="password"
                  autoComplete="new-password"
                />
                <div className="text-sm text-right mt-1 cursor-pointer">
                  <a
                    className="font-semibold text-blue-600 hover:text-blue-500"
                    onClick={() => {
                      setForgetPassword(true);
                    }}
                  >
                    Forgot password ?
                  </a>
                </div>
              </div>
              {/* <div className="mb-2 text-start">
                <InputField
                  control={control}
                  name="organization_code"
                  title="Organization Code"
                  autoComplete="off"
                  onChange={(e) => {
                    let val = e.target.value.toUpperCase();
                    setValue("organization_code", val);
                    localStorage.setItem("organization_code", val);
                  }}
                />
              </div> */}
            </div>
            <div>
              <button
                onClick={handleSubmit(handleLogin)}
                disabled={isLoading}
                className="flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 mt-3 font-semibold leading-6 text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Sign in
              </button>
            </div>
          </form>
        </div>
      </div>
      {forgetpassword && (
        <MainPageDialog
          title="Forget Password"
          modalSize="small"
          maxHeight={true}
          footerList={[
            {
              title: "Cancel",
              type: "cancel",
              action: () => {
                onCancelHandler();
              },
            },
            !showForgetinfo && {
              title: "Send Email",
              type: "save",
              action: forgetpasswordForm.handleSubmit(
                submitForgetPassordHandler
              ),
            },
          ]}
          onCancelHandler={() => {
            onCancelHandler();
          }}
        >
          {showForgetinfo ? (
            <>
              <p className="text-2xl font-medium mb-7">Check your email</p>
              <p className="mb-2">
                We've sent an email to{" "}
                <span className="font-bold">{showForgetinfo?.data}</span>. Click
                the link in the email to reset your password.
              </p>

              <p className="mb-2">
                If you don't see the email, check other places it might be, like
                your junk, spam, social or other folders.
              </p>

              <p className="mb-2">
                If you didn't receive the email then contact your facility
                provider.
              </p>
            </>
          ) : (
            <div className="flex flex-col ">
              <p className="text-2xl font-medium mb-7">
                Find your ethizo account
              </p>
              <InputField
                control={forgetpasswordForm.control}
                name="email"
                title="Enter your email or username "
                rules={{ required: true }}
                errors={forgetpasswordForm.formState.errors}
              />
              <p className="mb-2 mt-1">
                If you do not remember your username and email, please contact
                facility admin at support@ethizo.com
              </p>
            </div>
          )}
        </MainPageDialog>
      )}
    </>
  );
};
